import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {tntFirmware} from "../interfaces/tnt-firmware.interface";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TntFirmwareService {

  constructor(private http:HttpClient) { }

  index(
		filters: any, orderBy = '', order = 'asc',
		pageNumber = 0, pageSize = 5): Observable<any> {
		let params = new HttpParams();
		Object.keys(filters).forEach(function (key) {
			params = params.append(key, filters[key]);
		});
		params = params.append('order_by', orderBy);
		params = params.append('order', order);
		params = params.append('page', pageNumber);
		params = params.append('per_page', pageSize);
		return this.http.get(environment.apiUrl + '/tnt-firmwares', {
			params: params
		});
	}

	storeOrUpdate(tntFirmwares: tntFirmware): Observable<Object> {
		return tntFirmwares.id ? this.edit(tntFirmwares) : this.store(tntFirmwares);
	}

	store(tntFirmware: any): Observable<Object> {
		let formData = new FormData();

		if(tntFirmware.zip_file){
			formData.append('zip_file', tntFirmware.zip_file, tntFirmware.zip_file.name);
		}
		for(let key in tntFirmware){
			formData.append(key, tntFirmware[key]);
		}
		return this.http.post(environment.apiUrl + '/tnt-firmwares', formData);
	}

	edit(tntFirmware: any): Observable<Object> {
		let formData = new FormData();
		if(tntFirmware.zip_file){
			formData.append('zip_file', tntFirmware.zip_file, tntFirmware.zip_file.name);
		}
		for(let key in tntFirmware){
			formData.append(key, tntFirmware[key]);
		}
		formData.append('_method', 'PUT');
		return this.http.post(environment.apiUrl + '/tnt-firmwares/' + tntFirmware.id, formData);
	}
	destroy(id: number): Observable<Object> {
		return this.http.delete(environment.apiUrl + '/tnt-firmwares/' + id);
	}

	bulkDelete(ids: number[]): Observable<Object> {
		return this.http.patch(environment.apiUrl + '/tnt-firmwares/delete-multiple', {
			ids
		});
	}
}
